class DiversificationScore {
    byNumberOfProperties;
    byInvestmentDistribution;
    byPropertyType;
    byInvestmentType;
    byInvestmentStrategy;
    total;
    constructor(data) {
        this.byNumberOfProperties = data.byNumberOfProperties;
        this.byInvestmentDistribution = data.byInvestmentDistribution;
        this.byPropertyType = data.byPropertyType;
        this.byInvestmentType = data.byInvestmentType;
        this.byInvestmentStrategy = data.byInvestmentStrategy;
        this.total = data.total;
    }
}
export default DiversificationScore;
